import React from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import { history } from 'store';
import ProjectPriorityList from 'components/Agile/projectPriority/projectPriorityList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import ProjectPriorityAdd from 'components/Agile/projectPriority/projectPriorityAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import { MAX_PROJECT_PRIORITIES } from 'constants/project';

export class Component extends React.Component {

    addFavouriteProjectPriority = (data) => {
        this.props.addFavouriteProjectPriority(data);
    };
    onProjectPrioritySelect = (data) => {
        this.props.onProjectPrioritySelect(data);
    };
    onAddProjectPriority = () => {
        this.props.onAddProjectPriority();
    };
    onProjectPriorityClose = () => {
        this.props.onProjectPriorityClose();
    };
    onFilterProjectPriorityOptionSelect = (option) => {
        this.props.onFilterProjectPriorityOptionSelect(option);
    };
    onSaveProjectPriority = (data) => {
        this.props.onSaveProjectPriority(data);
    };
    onDeleteProjectPriority = (data) => {
        this.props.onDeleteProjectPriority(data);
    };
    onDeleteSelectedProjectPriority = () => {
        this.props.onDeleteSelectedProjectPriority();
    };
    filterProjectPriority = (projectPriorityName) => {
        if (projectPriorityName === '') {
            this.onFilterProjectPriorityOptionSelect(this.props.filterOption);
        } else {
            this.props.filterProjectPriority(projectPriorityName);
        }
    };
    handleProjectPriorityRequestClose = () => {
        this.props.handleProjectPriorityRequestClose();
    };
    getAllProjectPriority = () => {
        this.props.getAllProjectPriority();
    };
    getUnselectedAllProjectPriority = () => {
        this.props.getUnselectedAllProjectPriority();
    };
    onAllProjectPrioritySelect = () => {
        const selectAll = this.props.selectedProjectPrioritys < this.props.projectPriorityList.length;
        if (selectAll) {
            this.props.getAllProjectPriority();
        } else {
            this.props.getUnselectedAllProjectPriority();
        }
    };
    onToggleProjectPriorityDrawer = () => {
        this.props.onToggleProjectPriorityDrawer();
    };
    showProjectPriorityLoader = () => {
        this.props.showProjectPriorityLoader();
    }
    onProjectDashboard = () => {
        history.push('/app/project/default');
    };
    onSaveProject = (data) => {
        this.props.onSaveProject(data);
    };
    showProjectLoader = () => {
        this.props.showProjectLoader();
    };
    onUpdateProjectPriorities = (data) => {
        this.props.onUpdateProjectPriorities(data);
    };

    constructor() {
        super();
    }

    // componentDidUpdate(prevProps) {
    //     const { projectPriorityList } = this.props;
    //     if (projectPriorityList !== prevProps.projectPriorityList) {
    //         this.props.fetchProjectPrioritys();
    //     }
    // }

    updateSearchProjectPriority(evt) {
        this.props.updateSearchProjectPriority(evt.target.value);
        this.props.filterProjectPriority(evt.target.value);
    }

    projectPrioritySideBar = () => {
        const {
            projectPriorityList,
            updatingGlobalPriorities,
        } = this.props;
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span>{updatingGlobalPriorities ?
                        <IntlMessages id="sidebar.globalProjectPriorities" />
                        : <IntlMessages id="sidebar.projectPriorities" />}
                    </span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    {updatingGlobalPriorities ?
                        <div className="module-add-task">
                            <div>
                                <Button className="btn-block jr-btn" color="primary"
                                    onClick={this.onAddProjectPriority}
                                    disabled={projectPriorityList ?.length >= MAX_PROJECT_PRIORITIES}>
                                    <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw" />
                                    <span><IntlMessages id="projectPriority.addProjectPriority" /></span>
                                </Button>
                            </div>
                        </div>
                        : null}
                </CustomScrollbars>
            </div>
        </div>;
    };


    render() {
        const {
            width,
            projectPriority,
            projectPriorityList,
            addProjectPriorityState,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader,
            updatingGlobalPriorities,
            updatingProjectCostPriorities,
            projectList,
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">
                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleProjectPriorityDrawer.bind(this)}
                            sidebar={this.projectPrioritySideBar(projectPriority)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.projectPrioritySideBar(projectPriority)}
                    </div>
                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleProjectPriorityDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader
                                searchBar={false}
                                placeholder="Search project priority"
                                notification={false}
                                apps={false}
                                user={this.props.projectPriority}
                                onChange={this.updateSearchProjectPriority.bind(this)}
                                value={this.props.searchProjectPriority} />
                        </div>
                        <div className="module-box-content">
                            <div className="contact-item">
                                <div className="col">
                                    <h1>
                                        {updatingProjectCostPriorities ?
                                            <IntlMessages id="project.updateProjectCostPriorities" />
                                            : <IntlMessages id="project.updateProjectBusinessPriorities" />
                                        }
                                    </h1>
                                </div>
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    projectPriorityList && projectPriorityList.length > 0 ?
                                        <ProjectPriorityList data={projectPriorityList}
                                            width={width}
                                            updatingGlobalPriorities={updatingGlobalPriorities}
                                            projectList={projectList}
                                            addFavouriteProjectPriority={this.addFavouriteProjectPriority.bind(this)}
                                            onProjectPrioritySelect={this.onProjectPrioritySelect.bind(this)}
                                            onDeleteProjectPriority={this.onDeleteProjectPriority.bind(this)}
                                            onSaveProjectPriority={this.onSaveProjectPriority.bind(this)}
                                            showProjectPriorityLoader={this.showProjectPriorityLoader.bind(this)}
                                            showProjectLoader={this.showProjectLoader.bind(this)}
                                            onSaveProject={this.onSaveProject.bind(this)}
                                            onUpdateProjectPriorities={this.onUpdateProjectPriorities.bind(this)} />
                                        :
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <ProjectPriorityAdd
                    open={addProjectPriorityState}
                    projectPriority={{
                        'id': '',
                        'name': '',
                        'description': '',
                        'value': 0,
                    }}
                    updatingGlobalPriorities={updatingGlobalPriorities}
                    onSaveProjectPriority={this.onSaveProjectPriority}
                    onProjectPriorityClose={this.onProjectPriorityClose}
                    onDeleteProjectPriority={this.onDeleteProjectPriority}
                    showProjectPriorityLoader={this.showProjectPriorityLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleProjectPriorityRequestClose())}
                <NotificationContainer />

            </div>
        );
    }
}

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/projectPriority/component.js